//  ###########################################################################
//  ###########################################################################
//  ./jem-julia-event-manager/assets/js-src/script-form.js
"use strict"
/**
 * detect javascript
 *
 * switch html.no-js to html.js
 */
{
    const detect_javascript = function () {
        const elements = document.querySelectorAll('.no-js');
        if (!elements)
            return;
        for (let i = 0; i < elements.length; i++) {
            elements[i].classList.remove('no-js');
            elements[i].classList.add('js');
            elements[i].classList.add('education');
        }

    }

    detect_javascript();
}

/**
 * application-form duplicate and delete
 * duplicate and delete blocks for additional users
 *
 * @author Till Heinritz
 */
{
    /**
     * let for the block
     *
     * querySelectorAll() is static
     * getElementsByClassName() is dynamic
     * @link https://unicorntears.dev/posts/queryselectorall-vs-getelementsbyclassname/
     */
    let triggers_add = document.getElementsByClassName("less-more-add");
    let triggers_remove = document.getElementsByClassName("less-more-remove");

    /**
     * initialize block
     *
     * will be run on load the website
     * add event Listener
     */
    const initialize = () => {
        // leave script if elements dose not exist
        if (triggers_add.length === 0 || triggers_remove.length === 0) {
            return false;
        }

        // add event-listeners
        for (let i = 0; i < triggers_remove.length; i++) {
            triggers_remove[i].addEventListener("click", remove_item, false);
            triggers_add[i].addEventListener("click", add_item, false);
        }
    }

    /**
     * duplicate_parent
     *
     * duplicate form-elements for mor users
     */
    const add_item = (event) => {

        const target = event.target;
        const parent = target.closest('[class^="step"]');
        const items = parent.querySelectorAll('.less-more-item');
        const triggers = parent.querySelector('.less-more-triggers');
        const item = items[items.length - 1];
        const dup = item.cloneNode(true);
        const count = Number(item.dataset.count) + 1;
        dup.dataset.count = count;
        const basename = item.dataset.name;
        const inputs = dup.querySelectorAll('[name^="' + basename + '"]');

        for (let i = 0; i < inputs.length; i++) {
            let input = inputs[i];
            let name = input.name;
            input.name = name.replace('[' + (count - 1) + ']', '[' + count + ']');
        }
        parent.appendChild(dup);
        parent.appendChild(triggers);

        parent.querySelector('.less-more-remove').classList.remove('hidden')
    };

    /**
     * duplicate_parent
     *
     * duplicate form-elements for mor users
     */
    const remove_item = (event) => {
        const target = event.target;
        const parent = target.closest('[class^="step"]');
        const items = parent.querySelectorAll('.less-more-item');
        const item = items[items.length - 1];

        if (items.length <= 2) {
            target.classList.add('hidden');
        }
        if (items.length > 1) {
            item.remove();
        }
    }

    /**
     * call initialize
     */
    initialize();
}

/**
 * application-form validation at frontend
 *
 * @author Till Heinritz
 */
{
    /**
     * const for the block
     *
     * querySelectorAll() is static
     * getElementsByClassName() is dynamic
     * @link https://unicorntears.dev/posts/queryselectorall-vs-getelementsbyclassname/
     */
    const form = document.querySelector("#application-form");

    /**
     * initialize block
     *
     * will be run on load the website
     * add event Listener
     * call validation
     */
    const initialize = function () {
        // leave script if element dose not exist
        if (!form) {
            return false;
        }

        form.addEventListener("click", call_validation);
        form.addEventListener("keyup", call_validation);

        call_validation();
    }

    /**
     * validate_step
     *
     * checks if form-step is valide and adds/removes css classes
     * @param n
     */
    const validate_step = function (n) {
        const step = document.querySelector(".step_" + n);
        const invalid = step.querySelectorAll("input:invalid");
        const bottom_navigation = step.querySelector(".nav-bottom");
        const top_navigation = document.querySelector(".steps label[for=step_" + n + "]");

        if (invalid.length) {
            top_navigation.classList.remove("green");
            step.classList.remove("green");
            top_navigation.classList.add("red");
            step.classList.add("red");
            bottom_navigation.classList.add("invalid");
        } else {
            top_navigation.classList.remove("red");
            step.classList.remove("red");
            bottom_navigation.classList.remove("invalid");
            step.classList.add("green");
            top_navigation.classList.add("green");
        }
    }

    /**
     * validate_form
     *
     * checks if form is valide and adds/removes css classes
     */
    const validate_form = function () {
        const invalid = form.querySelectorAll("input:invalid");
        const sing_up = document.querySelector("label[for=application-sign_up]");
        const request = document.querySelector("label[for=application-request]");

        if (invalid.length) {
            sing_up.classList.add("invalid");
            request.classList.add("invalid");
        } else {
            sing_up.classList.remove("invalid");
            request.classList.remove("invalid");
        }
    }

    /**
     * call_validation
     *
     * call all parts of validation
     */
    const call_validation = function () {
        validate_step(1);
        validate_step(2);
        validate_step(3);
        validate_step(4);
        validate_form();
    }

    /**
     * call initialize
     */
    //initialize();
}

/**
 * application-form validation at frontend
 *
 * @author Rainer Krassa
 */

{
    const init = () => {
        document.querySelector("#application-sign_up").addEventListener("click", checked_required_input);
    }

    const checked_required_input = () => {
        console.log(document.querySelectorAll("#application-form :invalid")[0]);
        const error = document.querySelectorAll("#application-form :invalid")[0].closest("div.step").id;
        if (error.length >= 2) {
            console.log(error.split("_")[1]);
            const radiobutton = "#step_" + error.split("_")[1];
            document.querySelector(radiobutton).checked = true;
        }
    }

    init();
}

// EOF

